export const formatDateTime = (isoDate: string) => {
  const date = new Date(isoDate);
  return date.toLocaleString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * Formats a probability or percentage consistently.
 *
 * - The backend API returns values as percentages (0-100).
 * - This function now treats ALL non-NaN values as percentages.
 * - This prevents 1% (value=1) from being interpreted as probability 1.0 (100%).
 */
export const formatPercentage = (value: number, fractionDigits = 1) => {
  const num = Number(value);
  if (Number.isNaN(num)) return "–";

  // Previously: num > 1 ? num : num * 100;
  // Now: Always assume percentage (0-100 scale)
  const normalized = num;
  return `${normalized.toFixed(fractionDigits)}%`;
};
